import { NgModule } from '@angular/core';
import {
  DatastoreQuotationItemRevisionsModule,
  DatastoreQuotationRevisionsModule,
  DatastoreExchangeRatesModule,
  DatastoreProjectBudgetOptionsModule,
} from '@freelancer/datastore/collections';

@NgModule({
  imports: [
    DatastoreExchangeRatesModule,
    DatastoreProjectBudgetOptionsModule,
    DatastoreQuotationItemRevisionsModule,
    DatastoreQuotationRevisionsModule,
  ],
})
export class QuotationFormHelperModule {}
